<!-- Rectangle -->
<svg
  class="width-100"
  role="img"
  width="100"
  height="100"
  aria-labelledby="loading-aria"
  viewBox="0 0 100 100"
  preserveAspectRatio="none"
>
  <rect
    x="0"
    y="0"
    width="100%"
    height="100%"
    clip-path="url(#clip-path-rectangle)"
    style="fill: url('#fill-rectangle')"
  ></rect>
  <defs>
    <clipPath id="clip-path-rectangle">
      <rect x="0" y="0" rx="0" ry="0" width="100" height="100" />
    </clipPath>
    <linearGradient id="fill-rectangle">
      <stop offset="0.599964" stop-color="#E8EBEF" stop-opacity="1">
        <animate
          attributeName="offset"
          values="-2; -2; 1"
          keyTimes="0; 0.25; 1"
          dur="2s"
          repeatCount="indefinite"
        ></animate>
      </stop>
      <stop offset="1.59996" stop-color="#F3F5F8" stop-opacity="1">
        <animate
          attributeName="offset"
          values="-1; -1; 2"
          keyTimes="0; 0.25; 1"
          dur="2s"
          repeatCount="indefinite"
        ></animate>
      </stop>
      <stop offset="2.59996" stop-color="#E8EBEF" stop-opacity="1">
        <animate
          attributeName="offset"
          values="0; 0; 3"
          keyTimes="0; 0.25; 1"
          dur="2s"
          repeatCount="indefinite"
        ></animate>
      </stop>
    </linearGradient>
  </defs>
</svg>
